import styled from 'styled-components';

export const CompactEstateCardStyled = styled.div`
  display: flex;
  background-color: #ffffff;
  border-radius: 24px;
  min-height: 112px;
  min-width: 328px;
  padding: 12px;
  align-items: center;
  gap: 16px;
`;

export const CompactImageCard = styled.div<{ height: number; width: number }>`
  border-radius: 24px;
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  background-color: #d4e2fd;
  border: 5px solid #d4e2fd;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    width: auto;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const TitleCard = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  line-height: 24px;
`;

export const Price = styled.p`
  display: flex;
  gap: 2px;
  font-size: 14px;
  font-weight: 700;
  color: #0055fb;
  line-height: 20px;
  margin-top: 0;
  margin-bottom: 10px;
  align-items: baseline;

  & span {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Characteristics = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const CharacteristicItem = styled.div`
  display: flex;
  gap: 6px;
  align-items: baseline;
  color: #6C757D;
`;
